const REQUIRED_FIELD = 'Campo obligatorio';
const POSITIVE_NUMBER = 'Ingresa una cantidad mayor a 0';
const QUANTITY_AVAILABLE_EXCEEDED =
  'Excediste la cantidad disponible en la tienda';

export { REQUIRED_FIELD, POSITIVE_NUMBER, QUANTITY_AVAILABLE_EXCEEDED };
